var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('div',[_c('h1',[_vm._v("Загрузка")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }